// Toggle.tsx
import React from "react";

interface ToggleProps {
  on: boolean;
  onToggle: (value: boolean) => void;
}

export default function Toggle({ on, onToggle }: ToggleProps) {
  return (
    <button
      onClick={() => onToggle(!on)}
      className={`w-11 h-6 rounded-full flex items-center px-0.5 transition-colors ${
        on ? "bg-blue-500 justify-end" : "bg-gray-300 justify-start"
      }`}
    >
      <span className="w-5 h-5 bg-white rounded-full shadow" />
    </button>
  );
}
